<template>
  <footer class="bg-base-200 dark:bg-neutral text-base-content dark:text-neutral-content">
    <!-- Main Footer -->
    <div class="container mx-auto px-4 py-10">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- About Section -->
        <div class="space-y-4">
          <img :src="logo" alt="logo" class="md:h-12 h-10">
          <p class="opacity-75 max-w-md">
            12 farklı soru tipi, yapay zeka destekli analiz ve kişiselleştirilmiş öğrenme deneyimi ile eğitim sürecinizi optimize edin. Öğrenciler ve öğretmenler için tasarlanmış kapsamlı sınav/deneme platformu.
          </p>
          <div class="flex space-x-4 mt-4">
            <a href="https://www.instagram.com/kodlayanfenci/" target="_blank" rel="noopener noreferrer" class="btn btn-circle btn-ghost hover:bg-primary/20 transition-all duration-300" title="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@kodlayanfenci" target="_blank" rel="noopener noreferrer" class="btn btn-circle btn-ghost hover:bg-primary/20 transition-all duration-300" title="YouTube">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path>
              </svg>
            </a>
            <a href="https://www.facebook.com/groups/426463960849863" target="_blank" rel="noopener noreferrer" class="btn btn-circle btn-ghost hover:bg-primary/20 transition-all duration-300" title="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current">
                <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="space-y-4">
          <h3 class="text-lg font-bold">Hızlı Bağlantılar</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Ana Sayfa
              </router-link>
            </li>
            <li>
              <router-link to="/tos" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Hizmet Şartları
              </router-link>
            </li>
            <li>
              <router-link to="/privacy" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Gizlilik Politikası
              </router-link>
            </li>
            <li>
              <router-link to="/cookie-policy" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                Çerez Politikası
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact & Theme -->
        <div class="space-y-4">
          <h3 class="text-lg font-bold">İletişim</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/contact" class="btn btn-outline btn-sm mt-2">
                İletişim
              </router-link>
            </li>
          </ul>
          
          <!-- Theme Modal Button -->
          <div class="mt-6 pt-4 border-t border-base-300 dark:border-neutral-700">
            <button class="btn btn-outline btn-sm w-full" onclick="document.getElementById('theme-modal').showModal()">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
              </svg>
              Tema Seç
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="py-6 border-t border-base-300 dark:border-neutral-focus">
      <div class="container mx-auto px-4 text-center">
        <p class="text-sm opacity-75">Copyright © {{ new Date().getFullYear() }}  All rights reserved</p>
      </div>
    </div>

    <!-- Theme Selection Modal -->
    <dialog id="theme-modal" class="modal">
      <div class="modal-box bg-base-100 dark:bg-neutral">
        <h3 class="font-bold text-lg mb-4">Tema Seçimi</h3>
        <div class="space-y-3">
          <div class="grid grid-cols-1 gap-3">
            <!-- Light Theme -->
            <button 
              class="btn btn-outline justify-start" 
              data-theme="light"
              @click="setTheme('light')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
              <div class="text-left">
                <div class="font-medium">Açık Tema</div>
                <div class="text-xs opacity-60">Parlak ve temiz görünüm</div>
              </div>
            </button>

            <!-- Dark Theme -->
            <button 
              class="btn btn-outline justify-start" 
              data-theme="dark"
              @click="setTheme('dark')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
              <div class="text-left">
                <div class="font-medium">Koyu Tema</div>
                <div class="text-xs opacity-60">Göz yormayan karanlık görünüm</div>
              </div>
            </button>

            <!-- Auto Theme -->
            <button 
              class="btn btn-outline justify-start" 
              data-theme="auto"
              @click="setTheme('auto')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <div class="text-left">
                <div class="font-medium">Otomatik</div>
                <div class="text-xs opacity-60">Sistem ayarına göre değişir</div>
              </div>
            </button>
          </div>
        </div>
        <div class="modal-action">
          <form method="dialog">
            <button class="btn">Kapat</button>
          </form>
        </div>
      </div>
    </dialog>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import useUrl from '../../compositions/useUrl';

const { url, logo } = useUrl();

// Tema yönetimi
const setTheme = (theme) => {
  const html = document.documentElement;
  
  if (theme === 'auto') {
    // Sistem temasını takip et
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    if (mediaQuery.matches) {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.setAttribute('data-theme', 'light');
    }
    
    // Sistem teması değişikliklerini dinle
    mediaQuery.addEventListener('change', (e) => {
      if (html.getAttribute('data-theme') === 'auto') {
        html.setAttribute('data-theme', e.matches ? 'dark' : 'light');
      }
    });
  } else {
    html.setAttribute('data-theme', theme);
  }
  
  // Seçimi localStorage'a kaydet
  localStorage.setItem('theme', theme);
  
  // Modal'ı kapat
  document.getElementById('theme-modal').close();
};

// Sayfa yüklendiğinde tema ayarını yükle
onMounted(() => {
  const savedTheme = localStorage.getItem('theme') || 'auto';
  setTheme(savedTheme);
});
</script>